import { render, staticRenderFns } from "./CubeAlbum.vue?vue&type=template&id=1c2db799&scoped=true&"
import script from "./CubeAlbum.vue?vue&type=script&lang=js&"
export * from "./CubeAlbum.vue?vue&type=script&lang=js&"
import style0 from "./CubeAlbum.vue?vue&type=style&index=0&id=1c2db799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2db799",
  null
  
)

export default component.exports